import * as React from "react";
import { useContentSlideStore } from "@/state/contentSlideStore";

export const ContentSlideSidebar: React.FC = () => {
  const { sidebar, setSidebar } = useContentSlideStore();
const {precedentPanelMode} = useContentSlideStore();
const isGridMode = precedentPanelMode === "grid";

  return (
    <div
      className={"border-r-2 border-gray-200"}
      style={{
        width: "20%",
        height: "100vh",
        position: "fixed",
        top: 0,
        left: 0,
        padding: "1rem",
        color: "white",
        boxSizing: "border-box",
        backgroundColor: "#002945",
      }}
    >
      <img src="assets/AlphaScript-logo.png" alt="" className="w-36 h-auto object-contain mb-8" />

      <ul style={{ listStyle: "none", padding: 0 }}>
        <li
          style={{
            marginBottom: "0.5rem",
            marginLeft: "0.5rem",
            cursor: "pointer",
            color: sidebar === "share-price-performance" ? "#FF5C35" : "#ffffff",
            marginTop: isGridMode ? "5.1rem" : "0",
          }}
          onClick={() => setSidebar("share-price-performance")}
        >
          Share Price Performance
        </li>
      </ul>
    </div>
  );
};
